export default "__VITE_ASSET__f2d35248__"